import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-employment-availabilities-user-list-skeleton',
  templateUrl: './employment-availabilities-user-list-skeleton.component.html',
  styleUrls: ['./employment-availabilities-user-list-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmploymentAvailabilitiesUserListSkeletonComponent {}
